import { c as _c } from "react/compiler-runtime";
import { useErrorContext } from "@context-providers/error-boundary/error-handling-context";
import { errorFlagsSelector } from "@store/errors/errors-selector";
import { useAppSelector } from "@store/store-helper";
import { useEffect } from "react";

/**
 * Listen to the store and determine which type of error to show
 */
export function useErrorHandler() {
  const $ = _c(6);
  const {
    handleErrorWithToast,
    handleErrorWithDialog,
    handleErrorWithPage
  } = useErrorContext();
  const errorFlags = useAppSelector(errorFlagsSelector);
  let t0;
  let t1;
  if ($[0] !== errorFlags || $[1] !== handleErrorWithDialog || $[2] !== handleErrorWithPage || $[3] !== handleErrorWithToast) {
    t0 = () => {
      for (const key in errorFlags) {
        const errorFlag = errorFlags[key];
        bb5: switch (errorFlag.uiError) {
          case "toast":
            {
              handleErrorWithToast({
                ...errorFlag
              });
              break bb5;
            }
          case "dialog":
            {
              handleErrorWithDialog({
                ...errorFlag
              });
              break bb5;
            }
          case "page":
            {
              handleErrorWithPage({
                ...errorFlag
              });
            }
        }
      }
    };
    t1 = [errorFlags, handleErrorWithDialog, handleErrorWithPage, handleErrorWithToast];
    $[0] = errorFlags;
    $[1] = handleErrorWithDialog;
    $[2] = handleErrorWithPage;
    $[3] = handleErrorWithToast;
    $[4] = t0;
    $[5] = t1;
  } else {
    t0 = $[4];
    t1 = $[5];
  }
  useEffect(t0, t1);
}